<button class='open-modal' [class]='"state-" + state' (click)='activate.next()' aria-label='פתיחת אפשרויות הסינון'>
    <div class='img' *ngIf='state !== "inactive"'></div>
    <span *ngIf='message'>{{message}}</span>
    <!-- <div class='count' *ngIf='totalFilters'>{{totalFilters}}</div> -->
</button>